export function uploadFormData( upload, name, data, filename ) {
  let formData = new FormData();
  formData.append(
      name,
      new Blob([JSON.stringify(data)], {type: 'text/json'}),
      filename);
  upload(formData)
}
